// Shared section header for editorial-feeling rows on the homepage.
// Tiny on purpose — every section uses it for consistent rhythm.
export const SectionHeader = ({ icon: Icon, eyebrow, title, action }) => (
  <div className="flex items-end justify-between mb-4 gap-3">
    <div>
      {eyebrow && (
        <div className="flex items-center gap-2 mb-1">
          {Icon && <Icon className="w-4 h-4 text-emerald-500" />}
          <span className="text-[11px] uppercase tracking-widest text-muted-foreground font-semibold">
            {eyebrow}
          </span>
        </div>
      )}
      {title && (
        <h2 className="font-display font-bold text-xl sm:text-2xl tracking-tight text-foreground leading-tight">
          {title}
        </h2>
      )}
    </div>
    {action}
  </div>
);

export default SectionHeader;
